var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Event from 'typescript.events';
export var CrudModesEnum;
(function (CrudModesEnum) {
    CrudModesEnum["list"] = "list";
    CrudModesEnum["create"] = "create";
    CrudModesEnum["update"] = "update";
    CrudModesEnum["view"] = "view";
    CrudModesEnum["delete"] = "delete";
})(CrudModesEnum || (CrudModesEnum = {}));
;
var CrudMode = /** @class */ (function (_super) {
    __extends(CrudMode, _super);
    function CrudMode(initialMode, defaultMode) {
        if (initialMode === void 0) { initialMode = 'list'; }
        if (defaultMode === void 0) { defaultMode = 'list'; }
        var _this = _super.call(this) || this;
        _this.value = 'list';
        _this._defaultMode = 'list';
        _this.value = initialMode;
        _this._defaultMode = defaultMode;
        return _this;
    }
    Object.defineProperty(CrudMode.prototype, "Value", {
        get: function () { return this.value; },
        enumerable: false,
        configurable: true
    });
    ;
    Object.defineProperty(CrudMode.prototype, "Default", {
        get: function () { return this._defaultMode; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrudMode.prototype, "isList", {
        get: function () { return this.value === 'list'; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrudMode.prototype, "isView", {
        get: function () { return this.value === 'view'; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrudMode.prototype, "isCreate", {
        get: function () { return this.value === 'create'; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrudMode.prototype, "isUpdate", {
        get: function () { return this.value === 'update'; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrudMode.prototype, "isDelete", {
        get: function () { return this.value === 'delete'; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrudMode.prototype, "isDefault", {
        get: function () { return this.value === this._defaultMode; },
        enumerable: false,
        configurable: true
    });
    CrudMode.prototype.setList = function () { return this.set('list'); };
    CrudMode.prototype.setView = function () { return this.set('view'); };
    CrudMode.prototype.setCreate = function () { return this.set('create'); };
    CrudMode.prototype.setUpdate = function () { return this.set('update'); };
    CrudMode.prototype.setDelete = function () { return this.set('delete'); };
    CrudMode.prototype.setDefault = function () { return this.set(this._defaultMode); };
    CrudMode.prototype.setDefaultMode = function (mode) {
        return this._defaultMode = mode;
    };
    CrudMode.prototype.set = function (newValue) {
        if (CrudModesEnum[newValue])
            this._set(newValue);
        else
            this._set(this._defaultMode);
    };
    CrudMode.prototype._set = function (newValue) {
        if (CrudModesEnum[newValue]) {
            var oldValue = this.value;
            this.value = newValue;
            this.emit('changed', { current: newValue, old: oldValue });
            this.emit(newValue, { current: newValue, old: oldValue });
        }
    };
    CrudMode.prototype.on = function (eventName, listener) {
        return _super.prototype.on.call(this, eventName, listener);
    };
    return CrudMode;
}(Event));
export { CrudMode };
